<template>
    <div>
        <div class="container">
            <div class="row mt-5 p-5 shadow content-info" :style="estilo">
                <!-- Usa la pantalla de carga oficial (HyFLoader) dentro de la tarjeta. -->
                <HyFLoader variant="inline" class="col-12">
                    <p v-if="mensaje" class="mb-0">{{ mensaje[$i18n.locale] }}</p>
                </HyFLoader>
            </div>
        </div>
    </div>
</template>

<script>
import HyFLoader from '@/components/Loader/HyFLoader.vue';

export default {
    components: { HyFLoader },
    props: ["item", "estilo", "mensaje"]
};
</script>

<style>
.content-info {
    background-color: #ffffff;
    border-radius: 3px;
    transition: max-height 4s;
    font: Bold 17px/17px Lato;
    line-height: 25px;
    margin: 3px;
}
</style>
